<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tuEXgD/tc-custom/9781504068765.jpg?1725275754199" alt="This image is the cover for the book Tropic Death"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tropic Death
      </h1>
      <p class="bookDescription body article font2">
        <b>Stories by “one of the Harlem Renaissance’s most original writers . . . Gothic surrealism that fascinates and repels with the intensity of a sunstroke” (David Levering Lewis, Pulitzer Prize–winning author).</b><br/>  <br/> The only published work by Caribbean-born author Eric Walrond, <i>Tropic Death</i> was acclaimed by Langston Hughes for its “hard poetic beauty.” After having lived in Panama at one point during his early years, Walrond considered himself a spiritual native of the country, and in many of these stories, he portrays the diverse mix of workers who labored to build the Panama Canal. He also captures the beauty and danger of nature, especially the sun, in such tropical climates as Guiana and Barbados.<br/>  <br/> In “Drought,” a man grieves his dead daughter, while in “Panama Gold,” a tragic fire deprives a lonely woman of a chance at love. Two boys risk shark-infested waters to dive for coins thrown by tourists in “The Wharf Rats.” Seven more stories are included in the collection, which ends with the autobiographical “Tropic Death.”<br/>  <br/> “In prose . . . tough as the hanging vines from which monkeys leap and chatter, and as unsentimental as the blazing sun, ten intimate and body-touching pictures of the West Indies unroll themselves. There is nothing soft about this book. . . . The throbbing life and sun-bright hardness of these pages fascinate me. . . . And the ease and accuracy of Mr. Walrond’s West Indian dialects support one in the belief that he knows very well the people of who he writes.” —Langston Hughes, <i>New York Herald Tribune Book Review</i><br/>  <br/> “A book which excites and disturbs, oppresses and enchants the reader.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Walrond
      </h2>
      
      <p class="authorDescription body article">Eric Walrond was an Afro-Caribbean Harlem Renaissance writer and journalist. Born in British Guiana, he moved with his parents early in his life to Barbados, then Panama, New York City, and eventually England. His most famous book, <I>Tropic Death</I>, was published in New York City in 1926 when he was twenty-eight. Walrond was awarded the Guggenheim Fellowship for Fiction two years in a row, in 1928 and 1929.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c04f1bcc